import { StyleSheet, css } from 'aphrodite'
import React, { type ReactNode } from 'react'

interface BlurbSectionProps {
  text?: string
  children?: ReactNode
}

export default function BlurbSection({ text, children }: BlurbSectionProps) {
  return (
    <section className={css(styles.section)}>
      <p className={css(styles.blurbText)}>{children || text}</p>
    </section>
  )
}

const styles = StyleSheet.create({
  section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 1rem',
    '@media (min-width: 768px)': {
      padding: '48px 2rem',
    },
    '@media (min-width: 1024px)': {
      padding: '64px 3rem',
    },
  },
  blurbText: {
    textAlign: 'center',
    maxWidth: '100%',
    fontSize: '20px',
    lineHeight: '1.3',
    color: '#1F3D61',
    fontWeight: 600,
    '@media (min-width: 768px)': {
      maxWidth: '80%',
      fontSize: '26px',
      lineHeight: '1.25',
    },
    '@media (min-width: 1024px)': {
      maxWidth: '65%',
      fontSize: '32px',
      lineHeight: '1.2',
    },
  },
})
